import PropTypes from 'prop-types';

export default {
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
